/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCompositePriceRequest} from '@cash-web/protos/squareup/cash/marketprices/service.pb'
import {GetCompositePriceResponse} from '@cash-web/protos/squareup/cash/marketprices/service.pb'


export const getCompositePrice = (request: GetCompositePriceRequest, options?: CashRequestOptions) => post<GetCompositePriceRequest, GetCompositePriceResponse>("/2.0/cash/get-composite-price", request, {...options, rejectOnError: true })